module.exports = __webpack_public_path__ + "static/media/Industrial_new.af38f7d5.jpg";